import { Component, OnInit } from '@angular/core';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'ms-profile-contract',
  templateUrl: './profile-contract.component.html',
  styleUrls: ['./profile-contract.component.css']
})
export class ProfileContractComponent implements OnInit {

  submitted = false;
  error = false;
  success = false;
  data: any;

  constructor(
    private userService: UserService,
    private commonUtilService: CommonUtilService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();
    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.MY_PROFILE_CONTRACT");

    this.userService.getContractDetail().subscribe(data => {
      console.log(data);
      this.data = data;
      this.spinnerService.stop();
    });
  }

  getContractDoc() {
    this.spinnerService.start();
    this.commonUtilService.downloadFile(this.data.contract.name, this.data.contract.fileBinary, true);
    this.spinnerService.stop();
    return false;
  }
}
